import { Button } from 'antd';
import { useUnit } from 'effector-react';
import { CloseOutlined } from '@ant-design/icons';
import style from './ABStyles.module.css';
import ABLayerSelector from './ABLayerSelector.jsx';
import {
  $filterModal,
  applyFiltersEv,
  resetFilterModalEv,
} from '../../models/ABMarketsModel/index.js';
import useWindowSize from '../../hooks/useWindowSize.js';

function AbFiltersBlock() {
  const applyFilters = useUnit(applyFiltersEv);
  const [width, height] = useWindowSize();
  const filterModal = useUnit($filterModal);
  const resetFilterModal = useUnit(resetFilterModalEv);

  return (
    <div
      className={style.ab_filters}
      style={{
        right: width < 500 ? (filterModal ? 0 : '-200%') : 'unset',
      }}
    >
      <div className={style.ab_filters_title}>Фильтры</div>
      {width < 500 ? (
        <Button
          icon={<CloseOutlined style={{ fontSize: 24 }} />}
          className={style.ab_modal_close}
          shape="circle"
          onClick={resetFilterModal}
        />
      ) : (
        ''
      )}
      <ABLayerSelector />
      <Button
        className={style.ab_desc_button}
        style={{ width: '100%' }}
        onClick={applyFilters}
      >
        Применить
      </Button>
    </div>
  );
}

export default AbFiltersBlock;
